<template>
  <div class="pay">
    <div class="top">
      <div class="pay_shop" style="font-size: 0.14rem">
        <div class="pay_shop_name">
          <p>购买商品</p>
          <p>{{ payInfo.title }}</p>
        </div>
        <div class="pay_shop_number">
          <p>购买数量</p>
          <p>x{{ payInfo.num }}</p>
        </div>
        <div class="pay_shop_serial">
          <p>订单编号</p>
          <p>{{ payInfo.orderId }}</p>
        </div>
        <div class="pay_shop_money">
          <p>订单金额</p>
          <p style="font-weight: bold; color: #93683d">
            ￥{{ payInfo.totalMoney }}
          </p>
        </div>
      </div>
      <div class="pay_method">
        <h3>请选择支付方式</h3>
        <div class="line"></div>
        <van-radio-group v-model="radio" icon-size=".12rem">
          <van-cell-group>
            <!-- <van-cell
              title="支付宝支付"
              clickable
              @click="radio = '1'"
              :icon="require('../../assets/img/pay/icon_zhifubao@2x.png')"
            >
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell> -->
            <van-cell
              title="微信支付"
              clickable
              @click="radio = '1'"
              :icon="require('../../assets/img/pay/icon_weixin@2x.png')"
            >
              <template #right-icon>
                <van-radio name="1" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-radio-group>
      </div>
    </div>
    <div class="bottom">
      <van-button round type="info" class="MakeSurePay" @click="toPay"
        >确认支付￥{{ payInfo.totalMoney }}</van-button
      >
    </div>
  </div>
</template>

<script>
import { doPay, toWeiLogin, weixinBind, getUserInfo } from "../../api/home";
export default {
  data() {
    return {
      radio: "1",
      payInfo: {},
      PayParameters: {},
      code: "",
    };
  },
  // beforeCreate() {
  //   console.log(Boolean(this.$route.params.num));
  //   if (!this.$route.params.orderId) {
  //     this.$router.push('/makeSureTheOrder');
  //   }
  // },
  created() {
    if (this.$route.params.totalMoney) {
      this.payInfo = this.$route.params;
      sessionStorage.setItem("myOrder", JSON.stringify(this.payInfo));
    } else {
      this.payInfo = JSON.parse(sessionStorage.getItem("myOrder"));
    }
    if (window.location.href.split("code=")[1]) {
      const href = this.showWindowHref();
      this.code = href.code;
      this.weixin();
    }
    if (window.location.href.split("?isLogin")[1]) {
      getUserInfo().then((res) => {
        localStorage.setItem("aid", res.data.backdata.userinfo.id);
      });
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("myOrder");
  },
  mounted() {},
  methods: {
    // 微信绑定手机号
    weixin() {
      weixinBind({
        code: this.code,
      }).then((res) => {
        if (res.data.msg == "微信未绑定") {
          sessionStorage.setItem("openid", res.data.backdata.openid);
          Toast("登陆后绑定手机号");
          this.$router.push("/login");
        } else {
          localStorage.setItem("userToken", res.data.backdata.token);
          getUserInfo().then((res) => {
            localStorage.setItem("aid", res.data.backdata.userinfo.id);
          });
        }
      });
    },
    // 获取url query 拼接 参数
    showWindowHref() {
      var sHref = window.location.href;
      var args = sHref.split("?");
      if (args[0] == sHref) {
        return "";
      }
      var arr = args[1].split("&");
      var obj = {};
      for (var i = 0; i < arr.length; i++) {
        var arg = arr[i].split("=");
        obj[arg[0]] = arg[1];
      }
      return obj;
    },
    // 微信登录
    toWeiXi() {
      const url = window.location.href + "?isLogin=1"; // 获取当前的地址（支付订单的链接）
      toWeiLogin({
        backurl: url, // 后来再返回支付订单
      })
        .then((res) => {
          if (res.data.code == 0) {
            window.location.href = res.data.backdata.loginurl; // 微信登录链接
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发起支付
    toPay() {
      doPay({
        orderid: this.payInfo.orderId,
        paycode: "wxmp",
      }).then((res) => {
        var data = res.data;
        if (res.data.code == 0) {
          this.PayParameters = JSON.parse(res.data.backdata.PayParameters);
          if (typeof WeixinJSBridge === "undefined") {
            if (document.addEventListener) {
              document.addEventListener(
                "WeixinJSBridgeReady",
                this.onBridgeReady,
                false
              );
            } else if (document.attachEvent) {
              document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
              document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
            }
          } else {
            this.onBridgeReady();
          }
        } else {
          // 只进行了手机号登录，微信未登录
          if (res.data.code == 402) {
            // this.$dialog
            //   .confirm({
            //     message: "请先微信授权登录",
            //   })
            //   .then(() => {
            this.toWeiXi(); // 进行微信登录并绑定
            // })
            // .catch(() => {
            //   // on cancel
            // });
          }
        }
      });
    },
    onBridgeReady() {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        this.PayParameters,
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            this.$router.push({
              name: "支付成功",
              params: {
                payInfo: this.payInfo,
              },
            });
          }
        }
      );
    },
  },
};
</script>

<style lang='scss'>
.pay {
  padding: 0.79rem 0.15rem 0.22rem 0.15rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .top {
    .pay_shop {
      width: 100%;
      height: 1.46rem;
      background: #ffffff;
      border-radius: 0.08rem;

      div {
        padding: 0 0.15rem;
        height: 0.365rem;
        display: flex;
        justify-content: space-between;
        line-height: 0.365rem;

        font-size: 0.14rem;
        color: #333333;
      }
    }

    .pay_method {
      margin-top: 0.11rem;
      width: 100%;
      height: 1rem;
      background: #ffffff;
      border-radius: 0.08rem;
      padding: 0 0.15rem;

      h3 {
        height: 0.41rem;
        font-size: 0.12rem;
        color: #999a9c;
        line-height: 0.41rem;
      }

      .line {
        width: 3.15rem;
        height: 0.01rem;
        background: #f3f1f4;
      }

      // 支付宝微信图标
      .van-cell__left-icon {
        height: auto;
        margin-right: 0.08rem;

        .van-icon__image {
          width: 0.24rem;
          height: 0.24rem;
        }
      }

      .van-cell::after {
        border: none;
      }

      [class*="van-hairline"]::after {
        border: none;
      }

      .van-cell {
        padding: 0;
        display: flex;
        align-items: center;
        height: 0.51rem;

        font-size: 0.14rem;
      }

      .van-radio__icon {
        border: none;
        background: none;

        .van-icon {
          border: none;
          background: none;

          .van-icon::before {
            display: inline-block;
            height: 0.12rem;
            width: 0.12rem;
          }
        }

        .van-icon-success::before {
          display: none;
        }
      }

      .van-radio__icon--checked {
        background: url("../../assets/img/pay/icon_select@2x.png") no-repeat;
        width: 0.12rem;
        height: 0.12rem;
        background-size: contain;
      }
    }
  }

  .bottom {
    .MakeSurePay {
      border: none;
      width: 2.72rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      border-radius: 0.22rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
  }
}
</style>
